import CheckoutInfoProvider from "pages/checkout/providers/CheckoutInfoProvider";
import { InfoFormErrorsProvider } from "pages/checkout/providers/InfoFormErrorsProvider";
import Card from "shared/ui/card";
import CheckoutInfoFooter from "widgets/checkout/info-footer";
import CheckoutInfoInputs from "widgets/checkout/info-inputs";
import CheckoutSidebarProducts from "widgets/checkout/sidebar-products";
import CheckoutDeliveryPricesInfoBlock from "./CheckoutDeliveryPricesInfoBlock";
import { useStandardProductType } from "app/hooks/shared/standard-product/useStandardProductType";
import { useCartContext } from "app/providers/CartProvider";
import { useEffect } from "react";

const CheckoutInfo = () => {
  const { getCart } = useCartContext();
  const cart = getCart();
  const productAnalysis = useStandardProductType(cart);

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, []);

  // Check if there are any products with productType code "akoestischepanelen" or "accessoireakoestisch
  const showDeliveryPricesBlock =
    productAnalysis.someAkoestischepanelen ||
    productAnalysis.someAccessoireAkoestischPaneel;
  return (
    <CheckoutInfoProvider>
      <InfoFormErrorsProvider>
        <Card
          className="gg-border-b gg-border-t gg-px-4 gg-py-14 sm:gg-px-14 2xl:gg-px-32"
          shadow={false}
        >
          <section className="gg-grid gg-grid-cols-12 gg-items-start">
            <CheckoutInfoInputs className="gg-col-span-12 xl:gg-col-span-6 xl:gg-pr-12" />
            <div className="gg-col-span-6 gg-hidden gg-w-full gg-gap-y-5 xl:gg-grid">
              <CheckoutSidebarProducts />
              {showDeliveryPricesBlock && <CheckoutDeliveryPricesInfoBlock />}
            </div>
          </section>
        </Card>
        <CheckoutInfoFooter />
      </InfoFormErrorsProvider>
    </CheckoutInfoProvider>
  );
};
export default CheckoutInfo;
